module.exports = __webpack_public_path__ + "img/topup-providers.9fc2f3c2.png";